import { useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { PasswordRecoveryRequestDTO } from '@/core/api/dtos/request/auth/passwordRecovery'
import { useAuth } from '@/core/hooks/useAuth'
import { extractErrorMessage } from '@/shared/utils/helpers'

import { ForgotPasswordUI } from './ForgotPasswordUI'

export const ForgotPassword = () => {
	const { t } = useTranslation('auth')
	const form = useForm<PasswordRecoveryRequestDTO>({
		defaultValues: { email: '' },
		resolver: yupResolver(
			yup.object().shape({
				email: yup
					.string()
					.transform((value) => value?.toLowerCase() ?? '')
					.email(t('forgotPassword.errors.invalidEmail'))
					.required(t('forgotPassword.errors.required')),
			})
		) as any,
		mode: 'onChange',
		reValidateMode: 'onChange',
	})
	const [error, setError] = useState<string | null>(null)
	const [success, setSuccess] = useState(false)

	const { useForgotPassword } = useAuth()
	const { mutate, isPending } = useForgotPassword({
		options: {
			onSuccess: () => {
				setSuccess(true)
				setError(null)
				form.reset()
			},
			onError: (err: any) => {
				setSuccess(false)
				setError(extractErrorMessage(err))
			},
		},
	})

	const handleSubmit = (values: PasswordRecoveryRequestDTO) => {
		setError(null)
		setSuccess(false)
		mutate({ email: values.email.toLowerCase() })
	}

	return (
		<ForgotPasswordUI
			isLoading={isPending}
			error={error}
			success={success}
			form={form}
			onFinish={handleSubmit}
		/>
	)
}
